// root state
// 取菜单历史
let menuHistory = []
const menuHistoryStr = localStorage.getItem('menuHistory')
if (menuHistoryStr) {
  menuHistory = JSON.parse(menuHistoryStr)
}
export default {
  winHeight: window.innerHeight, // 当前窗口高度
  currentResourceId: null, // 当前的资源
  showBarList: window.uiMode === 'pc_only', // 下拉导航
  uiMode: window.uiMode,
  menuList: [],
  originMenuList: [], // 接口返回菜单列表
  menuHistory: menuHistory,
  showNav: false,
  navName: '',
  currentResourceUrl: 'home',
  chatDialog: false,
  currentResourcePath: 'home',
} // 菜单历史
